import { useEffect, useRef } from "react";

import { drawLegendSwatch, type LegendSwatch as Swatch } from "../../map/drawLegendSwatch";
import type { MapImages } from "../../map/drawMatchMap";
import type { MapColors } from "../../map/MapColors";
import type { MapScene } from "../../map/MapScene";

// Сторона образца, CSS-пиксели.
const SIZE = 26;

type LegendSwatchProps = {
  swatch: Swatch;
  scene: MapScene;
  images: Pick<MapImages, "camps" | "heroes">;
  colors: MapColors;
};

// Образец отметки для легенды — маленький canvas, нарисованный кодом карты.
export const LegendSwatch = ({ swatch, scene, images, colors }: LegendSwatchProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas?.getContext("2d") ?? null;
    if (canvas === null || context === null) {
      return;
    }
    const dpr = window.devicePixelRatio || 1;
    canvas.width = Math.round(SIZE * dpr);
    canvas.height = Math.round(SIZE * dpr);
    drawLegendSwatch(context, swatch, { size: SIZE, dpr }, scene, images, colors);
  }, [swatch, scene, images, colors]);
  return (
    <canvas
      ref={canvasRef}
      aria-hidden="true"
      data-swatch={swatch}
      className="size-[26px] shrink-0"
    />
  );
};
